import { Injectable } from '@angular/core';

export abstract class AbstractAnalyticsService {
    public initalize: (internalUser: boolean) => void;

    public setPageView: (path: string, title: string) => void;

    public setCompanyData: (
        companyName: string,
        email: string,
        userKey: string,
        firstName: string,
        lastName: string,
        isAdmin: boolean
    ) => void;

    public clearIdentifiersData: () => void;

    public setUserData: (
        userData: string,
        email: string,
        userKey: string,
        isAdmin: boolean
    ) => void;

    public triggerSingleDateFilterEvent: (reportName: string, dateOffset: number) => void;

    public triggerDateRangeFilterEvent: (
        reportName: string,
        startDateOffset: number,
        endDateOffset: number
    ) => void;

    public triggerSimpleEvent: (eventName: string) => void;

    public triggerEventWithPayload: (eventName: string, data: { [key: string]: any }) => void;
}
